export default __webpack_public_path__ + "static/media/hand.5fb19e05.png";